export default "__VITE_ASSET__DpFZ4AfW__"